// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_modal__G7VID {
  padding: 1.25rem 1.4rem 1.4rem;
  min-width: 28rem;
  max-width: 92vw;
  gap: 0.75rem; }

.styles_title__qIZS4 {
  margin: 0;
  font-size: 1.3rem; }

.styles_hint__R7b5t,
.styles_empty__tx9Ci {
  color: #808080b8;
  font-size: 0.9rem;
  line-height: 1.45;
  font-family: "Raleway", "Roboto", sans-serif; }

.styles_list__dCcU0 {
  gap: 0.65rem;
  margin-top: 0.35rem; }

.styles_cycleItem__FhFjT {
  width: 100%;
  box-sizing: border-box;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #8080802e;
  border-radius: 0.9rem;
  background: #fff; }

.styles_cycleCopy__Kxz3Z {
  min-width: 0;
  gap: 0.2rem; }

.styles_badge__EKedc {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #72abab; }

.styles_cycleName__VSZD0 {
  margin: 0;
  font-size: 1.05rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/cycles/components/AllocateActivityButton/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,YAAY,EAAA;;AAGhB;EACI,SAAS;EACT,iBAAiB,EAAA;;AAGrB;;EAEI,gBCCc;EDAd,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C,EAAA;;AAGhD;EACI,YAAY;EACZ,mBAAmB,EAAA;;AAGvB;EACI,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,2BCnBc;EDoBd,qBAAqB;EACrB,gBAAgB,EAAA;;AAGpB;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cCRgB,EAAA;;ADWpB;EACI,SAAS;EACT,kBAAkB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.modal {\n    padding: 1.25rem 1.4rem 1.4rem;\n    min-width: 28rem;\n    max-width: 92vw;\n    gap: 0.75rem;\n}\n\n.title {\n    margin: 0;\n    font-size: 1.3rem;\n}\n\n.hint,\n.empty {\n    color: $grey72;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    font-family: \"Raleway\", \"Roboto\", sans-serif;\n}\n\n.list {\n    gap: 0.65rem;\n    margin-top: 0.35rem;\n}\n\n.cycleItem {\n    width: 100%;\n    box-sizing: border-box;\n    gap: 1rem;\n    padding: 0.85rem 1rem;\n    border: 1px solid $grey18;\n    border-radius: 0.9rem;\n    background: #fff;\n}\n\n.cycleCopy {\n    min-width: 0;\n    gap: 0.2rem;\n}\n\n.badge {\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: $ocean_blue;\n}\n\n.cycleName {\n    margin: 0;\n    font-size: 1.05rem;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `styles_modal__G7VID`,
	"title": `styles_title__qIZS4`,
	"hint": `styles_hint__R7b5t`,
	"empty": `styles_empty__tx9Ci`,
	"list": `styles_list__dCcU0`,
	"cycleItem": `styles_cycleItem__FhFjT`,
	"cycleCopy": `styles_cycleCopy__Kxz3Z`,
	"badge": `styles_badge__EKedc`,
	"cycleName": `styles_cycleName__VSZD0`
};
export default ___CSS_LOADER_EXPORT___;
